import { render, staticRenderFns } from "./ValueVoucherStatusView.vue?vue&type=template&id=166a94fe&scoped=true"
import script from "./ValueVoucherStatusView.vue?vue&type=script&lang=js"
export * from "./ValueVoucherStatusView.vue?vue&type=script&lang=js"
import style0 from "./ValueVoucherStatusView.vue?vue&type=style&index=0&id=166a94fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a94fe",
  null
  
)

export default component.exports